import React, { useEffect, useContext } from "react";
import { useImmer } from "use-immer";
import { successMessage, errorMessage } from "../../../utils";
import { getPointPromotionsListApi } from "../api";
import { AppContext } from "../../../store/AppScopeProvider";

export const usePointPromotionList = ({ isList }) => {
  const { appState } = useContext(AppContext);
  const { globalData } = appState;

  const [state, setState] = useImmer({
    isLoading: true,
    allDataList: [],
    dataList: [],
    filter: {
      status: null,
    },
  });

  useEffect(() => {
    if (isList) {
      getPointPromotionsList();
    }
  }, [isList]);

  const getPointPromotionsList = async () => {
    try {
      setState((draft) => {
        draft.isLoading = true;
      });
      const res = await getPointPromotionsListApi();
      if (res.success) {
        setState((draft) => {
          draft.isLoading = false;
          draft.allDataList = res.data;
          draft.dataList = res.data;
        });
      }
    } catch (err) {
      setState((draft) => {
        draft.isLoading = false;
      });
    }
  };

  const handleStatusFilter = (event) => {
    const { value } = event.target;
    setState((draft) => {
      draft.filter.status = value || null;
      draft.dataList = value
        ? draft.allDataList.filter((item) => item.status === value)
        : draft.allDataList;
    });
  };

  const resetFilter = () => {
    setState((draft) => {
      draft.filter.status = null;
      draft.dataList = draft.allDataList;
    });
  };

  return {
    state,
    globalData,
    handleStatusFilter,
    resetFilter,
  };
};
